var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0004 16.0002H3.00042L4.50042 14.0002H19.0004C19.4314 14.0002 19.8124 13.7252 19.9484 13.3162L22.9484 4.31625C23.0514 4.01125 22.9994 3.67625 22.8114 3.41525C22.6234 3.15425 22.3214 3.00025 22.0004 3.00025H4.41442L1.70742 0.29325C1.31642 -0.09775 0.68442 -0.09775 0.29342 0.29325C-0.0975798 0.68425 -0.0975798 1.31625 0.29342 1.70725L3.00042 4.41425V12.6663L0.20042 16.4002C-0.0275798 16.7032 -0.0635798 17.1083 0.10542 17.4473C0.27542 17.7863 0.62142 18.0002 1.00042 18.0002H23.0004C23.5534 18.0002 24.0004 17.5522 24.0004 17.0002C24.0004 16.4482 23.5534 16.0002 23.0004 16.0002Z",
    fill: "#111111"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 22,
    r: 2,
    fill: "#111111"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22,
    r: 2,
    fill: "#111111"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.c9520597d98f43847711e20f679ea42f.svg";
export { ForwardRef as ReactComponent };